import { render, staticRenderFns } from "./AppAlertsDictionaryModal.vue?vue&type=template&id=af5383bc&scoped=true&"
import script from "./AppAlertsDictionaryModal.vue?vue&type=script&lang=js&"
export * from "./AppAlertsDictionaryModal.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertsDictionaryModal.vue?vue&type=style&index=0&id=af5383bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5383bc",
  null
  
)

export default component.exports